// extracted by mini-css-extract-plugin
export default {"content_list":"index_content_list_HZiAI","chip_item":"index_chip_item_rZ5of","top_40":"index_top_40_WVrJd"};